import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { getPaginatedData } from 'affiny-core/modules/helpers/pagination';
import { selectIsSub } from 'affiny-core/redux/selectors/subscriptionsSelectors';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import {
  selectReceivedVisitsCurrentPage,
  selectReceivedVisitsTotal,
} from '../../redux/selectors/visitsSelectors';
import {
  getVisits,
  postVisit,
  VISITS_PAGE_SIZE,
} from '../api/repositories/interactions/visits/visits.sagas';
import { refreshListsWhenNotEnoughElements } from '../favorites/saga';
import { ActionsOfType } from '../helpers';
import { checkHasCompletedProfile } from '../helpers/checkSaga';
import { EVisitsActionType, IVisitsAction, visitsActions } from './actions';

export function* postVisitSaga(
  action: ActionsOfType<IVisitsAction, EVisitsActionType.POST>
) {
  if (!(yield* checkHasCompletedProfile())) return;

  try {
    yield call(postVisit, action.payload.accountId);
    yield put(visitsActions.postVisitSuccess());
    yield call(refreshListsWhenNotEnoughElements);
  } catch (error) {
    yield put(visitsActions.postVisitError(action.payload.accountId));
    throw error;
  }
}

export function* getVisitsSaga(
  action: ActionsOfType<IVisitsAction, EVisitsActionType.GET_VISITS>
) {
  if (!(yield* checkHasCompletedProfile())) return;

  const isSub: boolean = yield select(selectIsSub);

  yield call(getPaginatedData as any, {
    pageSelector: selectReceivedVisitsCurrentPage,
    totalSelector: selectReceivedVisitsTotal,
    reset: action.payload.reset,
    apiCall: getVisits,
    resetAction: visitsActions.resetVisits,
    successAction: visitsActions.getVisitsSuccess,
    pageSize: VISITS_PAGE_SIZE,
    successActionParameters: [isSub],
  });
}

export function* visitsRootSaga() {
  yield all([
    takeLatest(
      EVisitsActionType.POST,
      handleAsyncStatus(postVisitSaga, EAsyncEventTypes.POST_VISITS)
    ),
    takeLatest(
      EVisitsActionType.GET_VISITS,
      handleAsyncStatus(getVisitsSaga, EAsyncEventTypes.GET_VISITS)
    ),
  ]);
}
